import { combine } from 'sagas/utils/effects';

import menuItems from './menu-items';
import restaurantMenuItems from './restaurant-menu-items';
import categoryMenuItems from './category-menu-items';

export default combine([menuItems, restaurantMenuItems, categoryMenuItems]);
